const image1 = 'https://oss.turingsenseai.com/15912490517312.png'
const image2 = 'https://oss.turingsenseai.com/15912492261070.png'
const image3 = 'https://oss.turingsenseai.com/15912492359174.png'
const image4 = 'https://oss.turingsenseai.com/15912492435518.png'
const image5 = 'https://oss.turingsenseai.com/15912492517167.png'
const image6 = 'https://oss.turingsenseai.com/15912493986749.png'
const image7 = 'https://oss.turingsenseai.com/1591249411114.png'
const image8 = 'https://oss.turingsenseai.com/15912492703615.png'
const image9 = 'https://oss.turingsenseai.com/15912492845259.png'
const image10 = 'https://oss.turingsenseai.com/15912494188885.png'
const content = `
<style type="text/css">.custom-image { margin-top: 10px }</style>
<p class="ql-align-center">
</p>
<p class="ql-align-center">
  <br>
</p>
<p class="ql-align-justify">
  温馨提示：在上传商品前您需仔细阅读并按照商品拍摄规范要求上传商品图片，请
  <strong style="color: rgb(237, 125, 49);">
    拍摄实物（对屏对图拍摄无效），禁止拼图，请勿遗漏瑕疵处。
  </strong>
  精美完整的图片有助于商品
  <strong style="color: rgb(237, 125, 49);">
    高效售出
  </strong>
  哦~
</p>
<p>
  <em>
    <u>
      如因您不按规定拍照、上传商品信息，给买家和平台造成损失的，您将承担相应责任。
    </u>
  </em>
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    1.&nbsp;正面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  将包包置于无杂物的背景中，完整拍摄包包的正面。确保无遮挡、无反光、光线充足、包包居于画面中央。
</p>
<p class="ql-align-center">
  <img calss="custom-image" src="${image1}">
</p>
<br>
<p class="ql-align-justify">
  <strong>
    2.&nbsp;反面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请完整拍摄包包的反面。
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image2}">
</p>
<br>
<p class="ql-align-justify">
  <strong>
    3.&nbsp;底面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请完整拍摄包包的底面；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image3}">
</p>
<p class="ql-align-center">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    4.&nbsp;边角（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请拍摄包包边角，如有瑕疵请拍瑕疵处；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image4}">
</p>
<p class="ql-align-justify">
  <br>
</p>
<p class="ql-align-justify">
  <strong>
    5.&nbsp;侧面（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请完整拍摄包包的任意一侧，如有瑕疵请拍摄瑕疵最严重的一侧；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image5}">
</p>
<br />
<p class="ql-align-justify">
  <strong>
    6.&nbsp;内里（必拍）
  </strong>
</p>
<p class="ql-align-justify">
  请将包撑开，清晰完整拍摄包包内里；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image6}">
</p>
<br />
<p class="ql-align-justify">
  <strong>
    7.&nbsp;手柄（选拍）
  </strong>
</p>
<p class="ql-align-justify">
  如有手柄，请务必拍摄，如有瑕疵请拍瑕疵处；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image7}">
</p>
<p class="ql-align-justify">
  <strong>
    8.&nbsp;五金（选拍）
  </strong>
</p>
<br />
<p class="ql-align-justify">
  请拍摄包上的五金（拉链头、铆钉、搭扣等），如有瑕疵请拍瑕疵处；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image8}">
</p>
<p class="ql-align-justify">
  <strong>
    9.&nbsp;附件（选拍）
  </strong>
</p>
<br />
<p class="ql-align-justify">
  请将附件（包装、防尘袋、肩带、身份卡等）放置于一起，完整拍摄。
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image9}">
  &nbsp;
</p>
<br />
<p class="ql-align-justify">
  <strong>
    10.&nbsp;其他（选拍）
  </strong>
</p>
<p>
  除以上部分包上还有磨损、染色、掉色、水渍、褶皱、开裂、断裂、变形、划痕、脱线等非商品原始状态的瑕疵，请清晰完整拍摄瑕疵部分；
</p>
<p class="ql-align-center">
<img calss="custom-image" src="${image10}">
</p>
<p>
  <br>
</p>
`
export default {
  content,
  title: '商品拍摄规范'
}
